document.addEventListener('alpine:init', () => {
  Alpine.data('accordion', () => ({
    initialized: null,
    activeItem: null,

    init() {
      this.$nextTick(() => this.ready());
    },

    ready() {
      this.activeItem = this.$refs.innerBlocks.children[0]?.dataset.blockId ?? null;
      setTimeout(() => (this.initialized = true));
    },

    toggleItem(blockId) {
      this.activeItem = this.activeItem === blockId ? null : blockId;
    },
  }));
});